<template>
  <div class="export" v-loading="loading">
    <div class="export__header"><span class="title">CASE REPORT</span></div>

    <div class="export__body">
      <div class="sub-header">
        <div>
          <ul class="date-type-checkbox">
            <li class="checkbox-header">CHOOSE DATE TYPE</li>

            <li class="ml-20 radio-block">
              <label>
                <input
                  type="checkbox"
                  class="input-checkbox"
                  value="collection_date"
                  v-model="date_check"
                  @change="uniqueCheck"
                />
                <h3>COLLECTION</h3>
              </label>
              <label>
                <input
                  type="checkbox"
                  value="received_date"
                  class="input-checkbox"
                  v-model="date_check"
                  @change="uniqueCheck"
                />
                <h3>RECEIVED</h3>
              </label>
              <label>
                <input
                  type="checkbox"
                  value="finalized_date"
                  class="input-checkbox"
                  v-model="date_check"
                  @change="uniqueCheck"
                />
                <h3>REPORTED</h3>
              </label>
              <label>
                <input
                  type="checkbox"
                  value="amended_date"
                  class="input-checkbox"
                  v-model="date_check"
                  @change="uniqueCheck"
                />
                <h3>AMENDED</h3>
              </label>
            </li>
          </ul>
        </div>
        <div class="button-wrapper">
         <el-button class="download-btn" @click="downloadCases(true)" v-if="!isBillingUser">
          Both Labs
        </el-button>
        <el-button class="download-btn" @click="downloadCases(false)">
          Download
        </el-button>
      </div>
      </div>
      <div class="inputs">
        <el-row :gutter="20">
          <el-form>
            <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text"> From Date </label>
                  <el-date-picker
                    v-model="from_date"
                    type="date"
                    format="MM-DD-YYYY"
                    :disabled-date="disabledDate"
                    placeholder="Select From Date"
                    :editable="false"
                  ></el-date-picker>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text"> To Date</label>
                  <el-date-picker
                    v-model="to_date"
                    type="date"
                    format="MM-DD-YYYY"
                    :disabled-date="disabledDate"
                    placeholder="Select To Date"
                    :editable="false"
                  ></el-date-picker>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
              <div
                class="case-creation__input"
                v-if="
                  getAuthenticatedUser &&
                  getAuthenticatedUser.user_type == 'LAB_TECHNOLOGIST' &&
                  getAuthenticatedUser.allowed_case_types
                "
              >
                <el-form-item>
                  <label for="text">Case Type </label>
                  <el-select
                    placeholder="Select Case Type"
                    v-model="case_types"
                    multiple
                    filterable
                    collapse-tags
                  >
                    <el-option
                      v-for="caseType in getUserBasedCaseTypes(caseTypes)"
                      :key="caseType"
                      :label="caseType.label"
                      :value="caseType.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="case-creation__input" v-else>
                <el-form-item>
                  <label for="text">Case Type </label>
                  <el-select
                    placeholder="Select Case Type"
                    v-model="case_types"
                    multiple
                    filterable
                    collapse-tags
                  >
                    <el-option
                      v-for="caseType in caseTypes"
                      :key="caseType"
                      :label="caseType.label"
                      :value="caseType.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text">Ordering Facility </label>
                  <el-select
                    placeholder="Select Ordering Facility"
                    v-model="hospital"
                    @change="fetchAllPhysicians"
                    multiple
                    filterable
                    collapse-tags
                  >
                    <el-option
                      v-for="hospital in hospitalsData.data"
                      :key="hospital"
                      :label="hospital.name"
                      :value="hospital._id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text">Ordering Facility Branch </label>
                  <el-select
                    placeholder="Select Ordering Facility Branch"
                    @change="fetchAllPhysiciansByHospitalBranch"
                    v-model="hospital_branch"
                    filterable
                    clearable
                  >
                    <el-option
                      v-for="(hospital, index) of hospitalBranches"
                      :key="index"
                      :value="hospital._id"
                      :label="hospital.display_name"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text"> Ordering Physician </label>
                  <el-select
                    v-model="ordering_physician"
                    placeholder="Select Ordering Physician"
                    filterable
                    collapse-tags
                  >
                    <el-option
                      v-for="physician in physiciansData.data"
                      :key="physician"
                      :label="physician.name"
                      :value="physician._id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
            <el-col
              :xl="3"
              :lg="4"
              :md="3"
              :sm="6"
              :xs="6"
              v-if="selectedCovidPanel"
            >
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text"> Covid Status </label>
                  <el-select
                    placeholder="Select Covid Status"
                    v-model="covid_status"
                    :filterable="true"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="(item, index) in covidStatuses"
                      :key="index"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text"> Status </label>
                  <el-select
                    placeholder="Select Status"
                    v-model="case_status"
                    :filterable="true"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="(status, index) in allCaseStatus"
                      :key="index"
                      :value="status.value"
                      :label="status.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text"> Assigned To </label>
                  <el-select
                    v-model="test_performed_by"
                    placeholder="Select user"
                    clearable
                    filterable
                    default-first-option
                    @focus="fetchAllUsers"
                    :loading="usersLoading"
                  >
                    <el-option
                      v-for="(user, index) in usersList"
                      :key="index"
                      :label="user.first_name + ' ' + user.last_name"
                      :value="user._id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6" v-if="hasPermission('cases', 'labdaq_view')">
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text"> Sales Rep </label>
                  <el-select
                    v-model="hospital_marketer"
                    placeholder="Select Sales Rep"
                    clearable
                    filterable
                    default-first-option
                    @focus="fetchAllUsers"
                    :loading="usersLoading"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="(user, index) in marketerData"
                      :key="index"
                      :label="user.first_name + ' ' + user.last_name"
                      :value="user._id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
          </el-form>
        </el-row>
      </div>
    </div>
    <div class="export__footer">
      <el-collapse v-model="caseReportCollapse">
        <el-row :gutter="15">
          <el-col :span="24">
            <div class="collapse-header">
              <el-collapse-item name="1">
                <div class="date-includes">
                  <div class="clear-btn">
                    <el-button
                      class="btn button-with-icon"
                      @click="handleClear"
                      :disabled="!this.activeFieldList.length"
                      >CLEAR ALL</el-button
                    >
                    <el-button
                      class="btn button-with-icon"
                      @click="handleCheckAllChange"
                      >SELECT ALL</el-button
                    >
                  </div>
                  <el-checkbox-group v-model="activeFieldList">
                    <ul class="check-list">
                      <li
                        v-for="(item, index) in casesExportFields"
                        :key="index"
                        class="search-checkbox"
                      >
                        <el-checkbox :label="item.value">
                          {{ item.label }}
                        </el-checkbox>
                      </li>
                    </ul>
                  </el-checkbox-group>
                </div>
              </el-collapse-item>
            </div>
          </el-col>
        </el-row>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import caseConstants from "@/config/constants/caseConstants";
import exportExcelHelper from "@/mixins/exportExcelHelper";
import caseDataHelper from "@/mixins/caseDataHelper";
import moment from "moment-timezone";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import GlobalHelper from "@/mixins/GlobalHelper";

export default {
  data() {
    return {
      disabledDate: (time) => {
        return time.getTime() > Date.now();
      },
      checkAll: true,
      activeFieldList: [],
      caseReportCollapse: "1",
      date_type: "",
      from_date: "",
      to_date: "",
      case_types: [],
      caseTypes: caseConstants.CASE_TYPES_DATA,
      hospital: "",
      physician: "",
      hospital_branch: "",
      ordering_physician: "",
      test_performed_by: "",
      hospital_marketer: [],
      hospital_marketing_manager: "",
      hospitalBranches: [],
      fieldList: [],
      covidStatuses: [
        {
          label: "POSITIVE",
          value: "POSITIVE",
        },
        {
          label: "NEGATIVE",
          value: "NEGATIVE",
        },
        {
          label: "INCONCLUSIVE",
          value: "INCONCLUSIVE",
        },
        {
          label: "RESULT AWAITED",
          value: "RESULT_AWAITED",
        },
      ],
      covid_status: [],
      case_status: "",
      allCaseStatus: caseConstants.CASE_STATUS,
      loading: false,
      date_check: [],
      hospitalsData: {},
      physiciansData: {},
      usersList: [],
      marketerData: [],
      usersLoading: false,
      roleGroups: {
        labUsers: [
          "LAB_ADMIN",
          "LAB_SUPER_ADMIN",
          "LAB_TECHNOLOGIST",
          "LAB_DATA_ASSISTANT",
          "ADMIN",
          "LAB_MANAGER",
          "LAB_DATA_ADMIN",
          "QC_MANAGER"
        ],
        facilityUsers: [
          "HOSPITAL_PHYSICIAN",
          "HOSPITAL_ADMIN",
          "HOSPITAL_ACCOUNT_MANAGER",
          "HOSPITAL_MARKETING_MANAGER",
          "SALES_DIRECTOR",
          "MARKETER",
          "ACCOUNT_MANAGER"
        ],
        billingUsers: [
          "BILLING_REPRESENTATIVE",
          "AR_LEAD",
          "AR_EXECUTIVE",
          "CP_LEAD",
          "CODING_LEAD",
          "CODING_EXECUTIVE",
          "POSTING_EXECUTIVE",
          "SR_FTE",
        ],
      },
      casesExportFields: [],
    };
  },
  mixins: [exportExcelHelper, caseDataHelper,UserPermissionsHelper,GlobalHelper],
  computed: {
    mappedSelectedOptions() {
      return this.activeFieldList.map((option) => {
        return this.exportExtraCasesExcelFields.find(
          (opt) => opt.value === option
        );
      });
    },
    ...mapGetters("hospitals", ["getAllHospitals"]),
    ...mapGetters("physicians", ["getAllPhysicians"]),
    ...mapGetters("cases", ["getDownloadCaseDataStatus"]),
    ...mapGetters("auth", ["getAuthenticatedUser"]),
    ...mapGetters("userAccounts", ["getAllUsers"]),
    getCaseTypes() {
      return (caseTypes) => {
        return (caseTypes || []).map((e) => this.caseTypeMap[e]);
      };
    },
    selectedCovidPanel() {
      return (
        this.case_types.indexOf("COVID") > -1 ||
        this.case_types.indexOf("COVID_FLU") > -1
      );
    },
  },
  created() {
    const userRole = this.getCurrentUser(); // Get the current user's role
    let userGroup;
    if (this.roleGroups.labUsers.includes(userRole)) {
      userGroup = "labUsers";
    } else if (this.roleGroups.facilityUsers.includes(userRole)) {
      userGroup = "facilityUsers";
    } else if (this.roleGroups.billingUsers.includes(userRole)) {
      userGroup = "billingUsers";
    }

    const accessibleFields = this.groupBasedFields[userGroup] || [];
    this.casesExportFields = [];

    // Filter exportExtraCasesExcelFields based on accessible fields
    this.exportExtraCasesExcelFields.forEach((obj) => {
      if (accessibleFields.includes(obj.value)) {
        this.casesExportFields.push(obj);
      }
    });
    this.activeFieldList = this.defaultExportCasesExcelFields
      .filter((field) => accessibleFields.includes(field.value))
      .map((field) => field.value);
  },
  async mounted() {
    // this.checkDefaultExport();
    this.fetchAllHospitals();
    await this.$store.dispatch("physicians/fetchAllPhysicians", {
      get_all: true,
    });
    this.physiciansData = JSON.parse(JSON.stringify(this.getAllPhysicians));
  },
  methods: {
    getCurrentUser() {
      return this.getAuthenticatedUser.user_type;
    },
    handleClear() {
      this.activeFieldList = [];
    },
    async fetchAllUsers() {
      this.usersLoading = true;
      await this.$store.dispatch("userAccounts/fetchAllUserAccounts", {
        get_all: true,
        order_by: "first_name",
        order_type: "asc",
        status:"ACTIVE"
      });
      if (this.getAllUsers && this.getAllUsers.data) {
        let usersForTestPerofmed = ["LAB_TECHNOLOGIST"];
        this.usersList = this.getAllUsers.data.filter((item) =>
          usersForTestPerofmed.includes(item.user_type)
        );
        let marketer = ["MARKETER","HOSPITAL_MARKETING_MANAGER","SALES_DIRECTOR"];
        this.marketerData = this.getAllUsers.data.filter((item) =>
          marketer.includes(item.user_type)
        );
      }
      this.usersLoading = false;
    },
    uniqueCheck(e) {
      this.date_check = [];
      if (e.target.checked) {
        this.date_check.push(e.target.value);
      }
      this.date_type = this.date_check.toString();
    },
    async fetchAllHospitals() {
      await this.$store.dispatch("hospitals/fetchAllHospitals", {
        get_all: true,
      });
      this.hospitalsData = JSON.parse(JSON.stringify(this.getAllHospitals));
    },
    async downloadCases(isBothLabs = false) {
      if (this.activeFieldList.length) {
        let params = {
          include: this.activeFieldList,
        };
        if (isBothLabs) {
         params.is_both_lab = true;
        }
        if (this.date_type) {
          if (this.date_type == "amended_date") {
            params.date_type = "amendement_details.amendment_time";
          } else {
            params.date_type = this.date_type;
          }
        }
        if (this.from_date != "") {
          params.from_date = moment
            .tz(this.getProfileData.lab.timezone)
            .set(this.getLabTimeZoneData(this.from_date))
            .startOf("day")
            .utc()
            .format();
        }

        if (this.to_date != "") {
          params.to_date = moment
            .tz(this.getProfileData.lab.timezone)
            .set(this.getLabTimeZoneData(this.to_date))
            .endOf("day")
            .utc()
            .format();
        }
        if (this.case_types != []) {
          params.case_types = this.case_types;
        }
        if (this.hospital != "") {
          params.hospitals = this.hospital;
        }
        if (this.ordering_physician != "") {
          params.ordering_physician = this.ordering_physician;
        }
        if (this.test_performed_by != "") {
          params.test_performed_by = this.test_performed_by;
        }
        if (this.hospital_marketer != []) {
          params.hospital_marketers = this.hospital_marketer;
        }
        if (this.hospital_marketing_manager != "") {
          params.hospital_marketing_manager = this.hospital_marketing_manager;
        }

        if (this.hospital_branch != "") {
          params.hospital_branch = this.hospital_branch;
        }

        if (this.covid_status && this.covid_status.length) {
          params.covid_statuses = this.covid_status;
        }

        if (
          this.case_status &&
          Array.isArray(this.case_status) &&
          this.case_status.length > 1
        ) {
          params.case_status = this.case_status;
        } else if (this.case_status && this.case_status.length == 1) {
          params.status = this.case_status.toString();
        } else if (Object.keys(params).indexOf("status") != -1) {
          delete params.status;
        }
        this.loading = true;
        await this.$store.dispatch("cases/downloadCaseData", params);
        this.loading = false;
        if (this.getDownloadCaseDataStatus) {
          // this.closeExportReportsDialog();
          this.resetFilters();
        } else {
          this.$message({
            message: "Error in downloading cases",
            type: "error",
          });
        }
      } else {
        this.$message({
          message: "Please select the data fields.",
          type: "warning",
        });
      }
    },
    resetFilters() {
      this.from_date = "";
      this.to_date = "";
      this.case_types = [];
      this.hospital = "";
      this.hospital_branch = "";
      this.ordering_physician = "";
      this.test_performed_by = "";
      this.hospital_marketer = [];
      this.hospital_marketing_manager = "";
      this.covid_status = [];
      this.case_status = "";
      this.date_type = "";
      this.date_check = [];
    },

    checkDefaultExport() {
      this.onExportReports();
    },
    async onExportReports() {
      this.loadFieldsList();
      await this.$store.dispatch("physicians/fetchAllPhysicians", {
        get_all: true,
      });
      this.physiciansData = JSON.parse(JSON.stringify(this.getAllPhysicians));
    },
    loadFieldsList() {
      this.exportExtraCasesExcelFields.forEach((obj) => {
        this.fieldList.push(obj.value);
      });
      this.activeFieldList = this.fieldList;
    },
    isCheckAll() {
      if (
        this.activeFieldList &&
        this.exportExtraCasesExcelFields &&
        this.activeFieldList.length &&
        this.exportExtraCasesExcelFields.length &&
        this.activeFieldList.length == this.exportExtraCasesExcelFields.length
      ) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },
    handleCheckAllChange() {
      this.casesExportFields.forEach((obj) => {
        this.fieldList.push(obj.value);
      });
      this.activeFieldList = this.fieldList;
    },
    async fetchAllPhysicians() {
      this.hospital_branch = null;
      this.ordering_physician = null;
      let params = {};
      let params1 = {};
      if (this.hospital && this.hospital.length) {
        params.hospitals = this.hospital;
        params1.hospitals = this.hospital;
      } else if (this.search_hospital && this.search_hospital.length) {
        params.hospitals = this.search_hospital;
        params1.hospitals = this.search_hospital;
      } else {
        params.get_all = true;
        params1.get_all = true;
      }
      await this.$store.dispatch("physicians/fetchAllPhysicians", params);
      if (params1.hospital_id) {
        await this.$store.dispatch("branches/fetchAllBranches", params1);
      } else if (params1.hospitals) {
        await this.$store.dispatch(
          "branches/fetchMultipleHospitalBranches",
          params1
        );
      }
    },
    async fetchAllPhysiciansByHospitalBranch(hospitalBranch) {
      this.ordering_physician = null;

      if (hospitalBranch) {
        let params = {
          hospital_branch: hospitalBranch,
          get_all: true,
        };
        await this.$store.dispatch("physicians/fetchAllPhysicians", params);
      } else {
        this.fetchAllPhysicians();
      }
    },
  },
};
</script>

<style></style>
